/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListTasksQueryResponse, ListTasksPathParams, ListTasksQueryParams, ListTasks400, ListTasks401, ListTasks403, ListTasks404, ListTasks409, ListTasks500 } from "../../types/planningTasksController/ListTasks.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listTasks } from "../../client/planningTasksController/listTasks.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listTasksQueryKey = (organizationId: ListTasksPathParams["organizationId"] | undefined, params?: ListTasksQueryParams) => [{ url: '/api/organizations/:organizationId/tasks', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListTasksQueryKey = ReturnType<typeof listTasksQueryKey>

export function listTasksQueryOptions(organizationId: ListTasksPathParams["organizationId"] | undefined, params?: ListTasksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listTasksQueryKey(organizationId, params)
        return queryOptions<ListTasksQueryResponse, ResponseErrorConfig<ListTasks400 | ListTasks401 | ListTasks403 | ListTasks404 | ListTasks409 | ListTasks500>, ListTasksQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listTasks(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List tasks across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/tasks}
 */
export function useListTasks<TData = ListTasksQueryResponse, TQueryData = ListTasksQueryResponse, TQueryKey extends QueryKey = ListTasksQueryKey>(organizationId: ListTasksPathParams["organizationId"] | undefined, params?: ListTasksQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListTasksQueryResponse, ResponseErrorConfig<ListTasks400 | ListTasks401 | ListTasks403 | ListTasks404 | ListTasks409 | ListTasks500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listTasksQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listTasksQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListTasks400 | ListTasks401 | ListTasks403 | ListTasks404 | ListTasks409 | ListTasks500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}